import React, { Component } from 'react'
import onClickOutside from 'react-onclickoutside'
import SelectUI from './SelectUI.js'

class SelectMultiSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    return (
      <SelectUI
        messageList={this.props.messageList}
        optionList={this.props.optionList}
        onChange={this.onChange}
        menuIsOpen={this.props.menuIsOpen}
        selectedKeys={this.props.selectedKeys}
        placeholderKey={this.props.placeholderKey}
        isMulti={true}
      />
    )
  }

  handleClickOutside = event => {
    if (this.props.onClickOutside)
      this.props.onClickOutside()
  }

  onChange = (selectedOptionList) => {
    this.props.onChange(selectedOptionList.map(option => option.value))
  }
}

export default onClickOutside(SelectMultiSF)
